import { useState, useEffect } from "react";
import { useConfig } from "../hooks/useConfig";
import { useAuthContext } from "../hooks/useAuthContext";
import axios from "axios";
import sedes from "../constants/sedes";
import horarios from "../constants/horarios";
import { materiasOfertaHoraria } from "../constants/materias";
import { useWindowContext } from "../hooks/useWindowContext";
import { useNavigate, useParams } from "react-router-dom";
import Tabla from "../components/Tabla";

const materias = materiasOfertaHoraria;

const VerHorariosPreasignados = () => {
  const { dni } = useParams();
  const { anio, cuat } = useConfig();
  const { user } = useAuthContext();
  const [horariosAsignados, setHorariosAsignados] = useState(null);
  const [horariosAsignadosLoading, setHorariosAsignadosLoading] =
    useState(true);
  const [error, setError] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [apellido, setApellido] = useState(null);
  const navigate = useNavigate();

  const reqHeader = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  };

  useEffect(() => {
    const fetchHorariosAsignados = async () => {
      setHorariosAsignadosLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `/api/admin/horarios-asignados/pre/${anio}/${cuat}/${dni}`,
          reqHeader,
        );
        setHorariosAsignados(response.data.horarios);
        setNombre(response.data.nombre);
        setApellido(response.data.apellido);
      } catch (error) {
        setError("Error al cargar los horarios preasignados:", error.message);
      } finally {
        setHorariosAsignadosLoading(false);
      }
    };
    fetchHorariosAsignados();
  }, [anio, cuat, setHorariosAsignados]);

  return (
    <>
      <div className="ver-horarios-asignados">
        {nombre && apellido && (
          <h3>{`Horarios preasignados a ${apellido}, ${nombre}`}</h3>
        )}
        {error && (
          <p>
            Hubo un error al cargar los horarios preasignados. Vuelva a intentar
            en otro momento.
          </p>
        )}
        {!horariosAsignadosLoading &&
          horariosAsignados &&
          horariosAsignados.length > 0 && (
            <Tabla opciones={horariosAsignados} />
          )}

        <button
          className="btn"
          onClick={() => {
            navigate("/admin/encuesta/preencuesta");
          }}
        >
          Volver
        </button>
      </div>
    </>
  );
};
export default VerHorariosPreasignados;
